import { Serializer } from '@teem/generic/serializer';
import { Resource } from '@teem/generic/resource';
import * as moment from 'moment';

export class TaxesSerializer implements Serializer {
	fromJson(json: any): Taxes {
		let invoice = new Taxes(json);
		return invoice;
	}

	toJson(invoice: Taxes): any {
		return invoice;
	}
}

export class Taxes implements Resource {
	public id: number;
	public uuid: string;
	public expense_type: string = "project";
	public receipt_number: string;
	public expense_date: string = moment().format('DD/MM/YYYY');
	public vendor_name: string;
	public vat_number: string;
	public description: string;
	public cost: number;
	public currency: number;
	public vat_percentage: number;
	public taxable_amount: number;
	public net_vat_amount_percent: number = 0;
	public attachment: string;

	constructor(input?: any) {
		if (input) {
			Object.assign(this, input);
		}
	}
}
